import { useCallback } from "react";
import { useWatch } from "react-hook-form";

/**
 * Adapts a react-hook-form form to a plain React useState() pair.
 */
export default function ({ control, getValues, reset }) {
  const formState = useWatch({ control });

  const setFormState = useCallback(
    (valueOrCallback) => {
      const value =
        valueOrCallback instanceof Function
          ? valueOrCallback(getValues())
          : valueOrCallback;
      reset(value);
    },
    [getValues, reset]
  );

  return [formState, setFormState];
}
